// Copyright © 2021 Move Closer
/**
 * Tile's sizing variant.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var TileSize;
(function (TileSize) {
    TileSize["XL"] = "XL";
    TileSize["L"] = "L";
    TileSize["S"] = "S";
})(TileSize || (TileSize = {}));
export var TileSizeMobile;
(function (TileSizeMobile) {
    TileSizeMobile["TILE_PLUS_TEXT"] = "tile-text";
    TileSizeMobile["TILE"] = "tile";
})(TileSizeMobile || (TileSizeMobile = {}));
export var ListType;
(function (ListType) {
    ListType["LIST"] = "list";
    ListType["THUMBNAILS"] = "thumbnail_list";
})(ListType || (ListType = {}));
